<template>
    <div>
        <v-select 
        :type="field.type" 
        :id="field.key" 
        :options="items"
        v-model="content"
        :label="label"
        :reduce="reduceItems"
        :taggable="constraints.selectables.custom"
        :multiple="constraints.selectables.multiple"
        ></v-select>
        <b-form-invalid-feedback :id="field.key" style="display:block">
          {{ errors[0] || null }}
        </b-form-invalid-feedback>
    </div>
</template>

<script>
import VSelect from 'vue-select'

export default {
    name: "IdentitySelectFieldText",
    components: {
        VSelect
    },
    props: {
        field: {
            type: Object
        },
        value: {
            type: String | Array
        },
        canReset: {
            type: Boolean,
            default: false
        },
        translator: {
            type: Function
        },
        reduce: {
            type: Function,
            default: null
        },
        label: {
            type: String,
            default: 'text'
        }
    },
    data: function() {
        return {
            errors: []
        }
    },
    computed: {
        content: {
            get() {
                if (this.value == "" || typeof this.value == 'array') {
                    return this.constraints.default || this.value
                }

                return this.value;
            },

            set(val) {
                this.check(val)
                this.$emit('input', val);
            }
        },
        constraints() {
            let constr = this.field.constraints

            return constr
        },
        items() {
            let items = this.constraints.selectables.items

            // empty value
            if (this.canReset) {
                items.push("")
            }

            return items
        },

        reduceItems(o) {
            if (this.reduce) return this.reduce

            return (o) => {
                if (typeof o == "object") return o.value

                return o
            }
        }
    },
    watch: {
        content(val) {
            this.check(val)
        }
    },
    methods: {
        check(val) {
            this.errors = []
                
            if (this.constraints.required) {
                if (val == "" || val === null) {
                    this.errors.push(this.translator("identityField.requiredField"))
                    return
                }

                let found = this.constraints.selectables.items.find(i => {
                    let v = val
                    if (typeof val == 'object') {
                        v = val[val.length - 1]
                    }

                    if (typeof i == "object") {
                        return i.value == v
                    } else {
                        return i == v
                    }
                })

                if (found === undefined && !this.constraints.selectables.custom) {
                    this.errors.push(this.translator("identityField.invalidSelection"))
                }
                    
            }
            
            this.$emit("error", {field: this.field.key, error: this.errors.length > 0})
        }
    },
    created() {
        if (this.constraints.required && this.constraints.default == "" && this.value === null) {
            if (this.constraints.selectables.multiple) {
                this.content = []
            } else {
                this.content = ''
            }
            
        }
    },

    mounted() {
        this.check(this.content)
    }
}
</script>